import {BaseContainerModel} from "../../base-container.model";


import {bl_wf_project_category_hdr_RowClass, bl_wf_project_category_hdr_RowInterface} from '../../../dbschema/bl_wf_project_category_hdr.model';

export class WfProjectCategoryContainerModel extends BaseContainerModel {
  bl_wf_project_category_hdr: bl_wf_project_category_hdr_RowInterface = new bl_wf_project_category_hdr_RowClass();
}
